<webu-recalls-template>
  <!--VEHICLE SWITCHER-->
  <ng-container ngProjectAs="vehicle-switcher">
    <webu-vehicle-switcher class="cit2-page-heading" (idSelected)="updateToActive($event)" [isModalClosable]="true"></webu-vehicle-switcher>
  </ng-container>
  <!--WARRANTY MILEAGE UPDATE-->
  <ng-container ngProjectAs="webu-warranty-mileage">
    <router-outlet name="webu-warranty-mileage"></router-outlet>
  </ng-container>
  <!--RECALL CENTER SEARCH-->
  <webu-recall-center-search-results
    [refreshDate]="getCurrentDate"
    [foundResultsFaq]="foundResultsFaq"
    [noResultsFoundFaq]="noResultsFoundFaq"
    [recallResults]="recallResults"
    [completeRecallResults]="completeRecallResults"
    [searchedVin]="_recallsVehicle.vin"
    [loading]="loading"
    [vehicleMake]="_recallsVehicle.make"
    [vehicleModel]="_recallsVehicle.model"
    [vehicleYear]="_recallsVehicle.year"
    [mmyFound]="mmyFound"
    [recallSearchCompleted]="flag.recallSearchCompleted"
    [warrantySearchCompleted]="flag.warrantySearchCompleted"
    [nhtsaRecallExists]="flag.nhtsaRecallExists"
    [nonNhtsaRecallExists]="flag.nonNhtsaRecallExists"
    [recallCenterWhatNowSecondParagraph]="'recallCenter_whatNow_secondParagraph' | translate"
    [isAnotherSearch]="flag.isAnotherSearch"
    [vinAttributes]="vinAttributes"
    [landingFaq]="landingFaq"
    [warrantyResults]="warrantyResults"
    [warrantyError]="flag.warrantyErrorState && !flag.invalidVinError"
    [recallsError]="flag.recallErrorState && !flag.invalidVinError">
  </webu-recall-center-search-results>
  <!--TAKATA STAY UP TO DATA-->
  <ng-container ngProjectAs="webu-takata-stay-up-to-date">
    <router-outlet name="webu-takata-stay-up-to-date"></router-outlet>
  </ng-container>
  <!--CREATE ACCOUNT WIDGET-->
  <ng-container ngProjectAs="create-account-widget">
    <router-outlet name="create-account-widget"></router-outlet>
  </ng-container>
  <!--DEALER NEED SERVICE-->
  <webu-dealer-need-service [prop51]="prop51" [prop44]="_recallsVehicle.vin" [prop53]="prop53"></webu-dealer-need-service>
  <!--MAIN CONTENT ERRORS-->
  <ng-container ngProjectAs="main-content-errors">
    <p ox-alert type="success" [show]="(isTakataSignupSuccess$ | async) === true">
      <span aria-atomic="true" role="alert" class="gb-body1" [translate]="'takata_recallSignupSuccess'"></span>
    </p>
    <p ox-alert type="error" [show]="(isTakataSignupSuccess$ | async) === false">
      <span aria-atomic="true" role="alert" class="gb-body1" [translate]="'takata_recallSignupError'"></span>
    </p>
    <!-- onStar legal messages -->
    <p ox-alert type="success" [show]="onStarLegalDisplayMsg">
      <span aria-atomic="true" role="alert" class="gb-body1" [translate]="'onstarLegal_acceptanceAlert'"></span>
    </p>
    <p ox-alert type="error" [show]="onStarLegalUpdtFailMsg">
      <span aria-atomic="true" role="alert" class="gb-body1" [translate]="'onstarLegal_serverErrorAlert'"></span>
    </p>
  </ng-container>
</webu-recalls-template>
